"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.7.3", "build_date": "2025-01-22T14:53:11.254Z", "build_branch": "development", "build_commit": "7a5df677c89fe8a4a2fb485263309d001b906577" };
//# sourceMappingURL=build_data.js.map